import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoading from '../common/componentsV2/elements/PageLoading';
import {
  addQuoteToCart,
  removeQuoteFromCart,
  resetTutelaLegaleQuotes,
  tutelaLegaleQuotesGetQuotes,
} from '../features/insuranceRequests/insuranceRequestsActions';
import { confirmAlert, generalAlertError } from '../common/utils/alerts';
import { TutelaLegaleQuotesStyles } from './RcTutelaLegaleQuotes.styles';
import ErrorComponent from '../common/components/ErrorComponent';
import {
  RiskContainer,
} from '../common/components/redesignComponents/Cards/ProfessionInfoCard.styles';
import ModalQuotesTutela from '../common/components/redesignComponents/ResultPageComponents/ModalQuotesTutela';
import TutelaLegaleModalButtons from '../common/components/redesignComponents/ResultPageComponents/TutelaLegaleModalButtons';
import ConversationModal from '../common/components/redesignComponents/Modal/ConversationModal';
import { EstimateContainer } from '../common/components/redesignComponents/common/Redesign.styles';
import { primaQuoteTypes } from '../common/constants';
import { V2FontImport } from '../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import TutelaLegaleSummaryCard from '../common/components/redesignComponents/ResultPageComponents/v2/TutelaLegaleSummaryCard';
import QuoteCostSummaryCard from '../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';
import {
  OutlineActionButton,
  ActionButtonBadge,
} from '../common/components/redesignComponents/ResultPageComponents/v2/SecondaryActionButtons.styles';
import { ChatIcon } from '../common/components/redesignComponents/ResultPageComponents/v2/ActionIcons';

export default function RcTutelaLegaleQuotes() {
  const navigate = useNavigate();
  const { requestToken } = useParams();

  const state = useSelector(
    (store) => store.insuranceRequests.tutela_legale_quotes,
  );

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const {
    loading,
    userData,
    customer,
    quotations,
    addingQuote,
    processingQuote,
    riskQuotations,
    error,
    thread,
    est_provvigioni,
  } = state;
  const [showConversationModal, setShowConversationModal] = useState(false);

  const refresh = () => tutelaLegaleQuotesGetQuotes(requestToken);
  const silentRefresh = () => tutelaLegaleQuotesGetQuotes(requestToken);

  const fetchQuotes = () => {
    tutelaLegaleQuotesGetQuotes(requestToken);
  };

  const modifyData = () => {
    let firstQuote = null;
    if (quotations && quotations.res_civile && quotations.res_civile.length > 0) {
      firstQuote = quotations.res_civile[0];
    }

    const path = firstQuote ? `/quote/tutela-legale/${firstQuote.sub_product}` : '/quote/tutela-legale';

    navigate(path, {
      state: { requestToken },
    });
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addQuoteToCart(quoteId, fetchQuotes, modifyData));
  };

  useEffect(() => {
    tutelaLegaleQuotesGetQuotes(requestToken);

    return () => {
      resetTutelaLegaleQuotes();
    };
  }, []);

  // useEffect(() => {
  //   if (userData && userData.is_expired === true && userData.request_token === requestToken) {
  //     navigate('/quote/tutela-legale', {
  //       state: { requestToken },
  //     });
  //     generalAlertError(
  //       'È necessario compilare nuovamente il preventivo!',
  //       'Link e scaduto!',
  //     );
  //   }
  // }, [userData, requestToken]);

  if (loading) {
    return <PageLoading />;
  }

  if (error !== null) {
    return <ErrorComponent error={error} />;
  }

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeQuoteFromCart(quoteId, fetchQuotes, modifyData));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }

    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (riskQuotations && riskQuotations[type.id] !== undefined) {
        for (let i = 0; i < riskQuotations[type.id].length; i++) {
          const item = riskQuotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount;

    return total.toFixed(2);
  };

  const handleRequestPurchase = () => {
    if (processingQuote === null) {
      generalAlertError('Seleziona Prima La Responsabilita Civile', 'Errore');
      return;
    }

    navigate(`/quotes/tutela-legale/purchase/${requestToken}`);
  };

  return (
    <>
      {showConversationModal && (
        <ConversationModal
          requestId={userData?.id}
          threadId={thread?.thread_id}
          onClose={() => {
            setShowConversationModal(false);
            silentRefresh();
          }}
          onUpdated={() => silentRefresh()}
          location="quotation_profession_result"
        />
      )}
      <V2FontImport />
      <TutelaLegaleQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <TutelaLegaleSummaryCard
              modificaDati={modifyData}
              customer={customer}
              insuranceRequest={userData}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={riskQuotations}
              primaQuoteTypes={primaQuoteTypes}
              getTotal={getTotal}
              onProcedi={() => handleRequestPurchase()}
              est_provvigioni={est_provvigioni}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12">
              <EstimateContainer>
                <div className="d-flex gap-2 justify-content-end">
                  <div>
                    <OutlineActionButton
                      type="button"
                      onClick={() => {
                        setShowConversationModal(true);
                        if (thread?.unreadMessages > 0) silentRefresh();
                      }}
                    >
                      <ChatIcon />
                      Contatta il Backoffice
                      {thread?.unreadMessages > 0 && (
                        <ActionButtonBadge>
                          {thread.unreadMessages}
                          <span className="visually-hidden">messaggi non letti</span>
                        </ActionButtonBadge>
                      )}
                    </OutlineActionButton>
                  </div>
                </div>
              </EstimateContainer>
            </div>
          </div>

          {quotations && !quotations.res_civile
            && (
              <div className="alert alert-info mx-2" role="alert">
                <h4 className="alert-heading">Avviso!</h4>
                <p className="m-0">Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </div>
            )}

          {quotations && quotations.res_civile
            && (
              <>
                <RiskContainer className="mb-3 pb-3 result-home-third-step">
                  {quoteTypes.map((type, index) => (
                    <React.Fragment key={index}>
                      {quotations && quotations[type.id] && (
                        <TutelaLegaleModalButtons
                          userData={userData}
                          processingQuote={processingQuote}
                          type={type}
                          removeItemFromCart={removeItemFromCart}
                          riskQuotations={riskQuotations}
                          quotations={quotations}
                        />
                      )}
                    </React.Fragment>
                  ))}
                </RiskContainer>
                {quoteTypes.map((type, index) => (
                  <ModalQuotesTutela
                    userData={userData}
                    type={type}
                    index={index}
                    addingQuote={addingQuote}
                    quotations={quotations}
                    selectQuotation={selectQuotation}
                    processingQuote={processingQuote}
                    refresh={refresh}
                  />
                ))}
              </>
            )}

        </div>

      </TutelaLegaleQuotesStyles>
    </>
  );
}
